import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";

export const AccessPanel = ({ auth }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try { setData((await api.get("/users", await auth())).data); } catch (e) { toast.error(errorText(e)); }
    })();
  }, [auth]);

  const change = async (uid, role) => {
    try {
      await api.patch(`/users/${uid}/role`, { role }, await auth());
      setData((d) => ({ ...d, users: d.users.map((u) => (u.user_id === uid ? { ...u, role } : u)) }));
      toast.success("Access updated");
    } catch (e) {
      toast.error(errorText(e));
    }
  };

  if (!data) return null;
  return (
    <div className="mt-6 space-y-3" data-testid="access-panel">
      <p className="text-sm text-[#f7f1e1]/65">People who have signed in to the owner area. Only admins can see bookings.</p>
      {data.users.map((u) => (
        <div key={u.user_id} className="glass rounded-2xl p-4 flex flex-wrap items-center gap-4" data-testid={`access-row-${u.user_id}`}>
          <span className="mr-auto text-sm">{u.email || u.user_id}</span>
          <select className="field !mt-0 !w-auto !py-1.5 text-sm" value={u.role} onChange={(e) => change(u.user_id, e.target.value)} data-testid={`access-role-select-${u.user_id}`}>
            {data.roles.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      ))}
    </div>
  );
};
